import React, { useEffect, useState } from 'react'
import axios from 'axios'
import AdminDashboard from './AdminDashboard'
import Swal from 'sweetalert2'

const Localjobapen = () => {

    const [localjobs, setLocaljobs] = useState([])


    const getAll = () => {
        axios.get('https://api.myskills.lk/ljobs/getpending').then((response) => {
            setLocaljobs(response.data)
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {

        getAll();

    }, [])



    const [searchTerm, setSearchTerm] = useState('')

    const handleSearch = (e) => {
        e.preventDefault()
        setSearchTerm(e.target.value)
    }

    const filteredInstitutes = localjobs.filter((institute) =>
        institute.jobtit && institute.jobtit.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const UpdateApprove = (e, id) => {
        e.preventDefault();
        console.log(id);

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve this local job?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post('https://api.myskills.lk/ljobs/updateapprove', { id: id, approve: 1 }).then((response) => {
                    getAll();
                    Swal.fire({
                        title: "Approved!",
                        text: "The local job has been approved.",
                        icon: "success"
                    });
                }).catch((err) => {
                    console.log(err);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to approve the local job.",
                        icon: "error"
                    });
                });
            }
        });
    }

    const UpdateDelete = (e, id) => {
        e.preventDefault();

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this local job?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`https://api.myskills.lk/ljobs/delete/${id}`).then((response) => {
                    getAll();
                    Swal.fire({
                        title: "Deleted!",
                        text: "The local job has been deleted.",
                        icon: "success"
                    });
                }).catch((err) => {
                    console.log(err);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the local job.",
                        icon: "error"
                    });
                });
            }
        });
    }
    const sendEmail = (email, name, id) => {
      

        const data = {
            email: email,
            name: name,
            id: id
        }

        axios.post('https://api.myskills.lk/ljobs/sendemail', data).then((res) => {
            console.log("send email")
        })

    }




    console.log(localjobs);
    return (
        <div>

            <AdminDashboard />

            <div className='AllViews-admin'>

                <div className="search-icon-admin admin-institute-search">

                    <h1>PENDING LOCAL JOBS</h1>
                    <div>
                        <form >
                            <input type="text" onChange={handleSearch} id="" placeholder='Search Item' />
                            <input type="submit" value="SEARCH" />
                        </form>
                    </div>
                </div>

                <div className="scroller-box">
                    <div className="table-institute">
                        <table>
                            <thead>
                                <tr>
                                    <th>Company Name</th>
                                    <th>Email</th>
                                    <th>Website</th>
                                    <th>Tel no</th>
                                    <th>Job Title</th>
                                    <th>Job Level</th>
                                    <th>Job Type</th>
                                    <th>Action</th>
                                    <th>View</th>

                                </tr>
                            </thead>

                            <tbody>


                                {filteredInstitutes.length > 0 ? (
                                    filteredInstitutes.map((insti) => (
                                        <tr key={insti.id}>
                                            <td>{insti.cname}</td>
                                            <td>{insti.email}</td>
                                            <td>{insti.web}</td>
                                            <td>{insti.contact}</td>
                                            <td>{insti.jobtit}</td>
                                            <td>{insti.joblevel}</td>
                                            <td>{insti.jobtype}</td>
                                            <td>
                                                <button id="view-web">
                                                    <a href={`/localjview/${insti.id}`}>SITE VIEW</a>
                                                </button>
                                            </td>
                                            <td id="action-buttons">
                                                <button
                                                    onClick={(e) => {
                                                        UpdateApprove(e, insti.id);
                                                        sendEmail(insti.email, insti.cname, insti.id)
                                                    }}
                                                    id="app-details"
                                                >
                                                    APPROVE
                                                </button>
                                                <button
                                                    onClick={(e) => {
                                                        UpdateDelete(e, insti.id);
                                                    }}
                                                    id="del-details"
                                                >
                                                    DELETE
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: 'center', padding: '10px' }}>
                                            Search data not found
                                        </td>
                                    </tr>
                                )}





                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )
}

export default Localjobapen